<p-toast [style]="{marginTop: '80px'}"></p-toast>
<div class="container">
    <div class="row">
        <div class="col-12">
            <h1>Registre su Organizaci&oacute;n</h1>
            <p-steps [model]="items" styleClass="steps-custom" [(activeIndex)]="activeIndex" [readonly]="true">
            </p-steps>
        </div>
    </div>
    <form [formGroup]="organizationForm" class="formClass boxed boxed-p" *ngIf="activeIndex == 0"
        (ngSubmit)="onSubmitOrganization();">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label for="name" class="required">Nombre:</label>
                    <input type="text" class="form-control" formControlName="name"
                        placeholder="Ingrese el nombre de la organizacion"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['name'].errors }">
                    <div *ngIf="organizationSubmitted && organizationControls['name'].errors" class="invalid-feedback">
                        <div *ngIf="organizationControls['name'].errors['required']">El nombre es requerido.</div>
                    </div>
                </div>
                <div class="form-group" *ngIf="isPhysicalPerson">
                    <label for="lastName" class="required">Apellido:</label>
                    <input type="text" class="form-control" formControlName="lastName" placeholder="Ingrese el apellido"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['lastName'].errors }">
                </div>
                <div class="form-group">
                    <label for="personTypeId" class="required">Tipo de Identificaci&oacute;n:</label>
                    <select placeholder="Seleccione el tipo de identificaci&oacute;n" formControlName="personTypeId"
                        class="form-control"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['personTypeId'].errors }"
                        (change)="onPersonTypeChange($any($event.target).value)">
                        <option *ngFor="let personType of personTypes" [value]="personType.id">{{personType.name}}
                        </option>
                    </select>
                    <div *ngIf="organizationSubmitted && organizationControls['personTypeId'].errors"
                        class="invalid-feedback">
                        <div *ngIf="organizationControls['personTypeId'].errors['required']">El tipo de
                            identificaci&oacute;n
                            es requerido.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="identification" class="required">Identificaci&oacute;n:</label>
                    <input type="text" class="form-control" formControlName="identification"
                        placeholder="Ingrese el numero de identificaci&oacute;n"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['identification'].errors }">
                    <div *ngIf="organizationSubmitted && organizationControls['identification'].errors"
                        class="invalid-feedback">
                        <div *ngIf="organizationControls['identification'].errors['required']">El numero de
                            identificaci&oacute;n es
                            requerido.</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="comercialName" class="required">Nombre comercial:</label>
                    <input type="text" class="form-control" formControlName="comercialName"
                        placeholder="Ingrese el nombre comercial"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['comercialName'].errors }">
                </div>
                <div class="form-group">
                    <label for="emailAddress" class="required">Correo electr&oacute;nico:</label>
                    <input type="text" class="form-control" formControlName="emailAddress"
                        placeholder="Ingrese el correo electr&oacute;nico"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['emailAddress'].errors }">
                    <div *ngIf="organizationSubmitted && organizationControls['emailAddress'].errors"
                        class="invalid-feedback">
                        <div *ngIf="organizationControls['emailAddress'].errors['required']">El correo es requerido.
                        </div>
                        <div *ngIf="organizationControls['emailAddress'].errors['email']">Formato de correo
                            inv&aacute;lido.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="phoneNumber1" class="required">Tel&eacute;fono:</label>
                    <input type="text" class="form-control" formControlName="phoneNumber1"
                        placeholder="Ingrese el n&uacute;mero de tel&eacute;fono" mask="(000) 0000-0000"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['phoneNumber1'].errors }">
                    <div *ngIf="organizationSubmitted && organizationControls['phoneNumber1'].errors"
                        class="invalid-feedback">
                        <div *ngIf="organizationControls['phoneNumber1'].errors['required']">El tel&eacute;fono es
                            requerido.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="economicActivityId" class="required">Actividad econ&oacute;mica:</label>
                    <select placeholder="Seleccione la actividad econ&oacute;mica" formControlName="economicActivityId"
                        class="form-control"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['economicActivityId'].errors }">
                        <option *ngFor="let activities of economicActivities" [ngValue]="activities.Id">
                            {{activities.Name}}</option>
                    </select>
                    <div *ngIf="organizationSubmitted && organizationControls['economicActivityId'].errors"
                        class="invalid-feedback">
                        <div *ngIf="organizationControls['economicActivityId'].errors['required']">La actividad
                            econ&oacute;mica es
                            requerida.
                        </div>
                    </div>
                </div>
            </div>



            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label for="countryId" class="required">Pa&iacute;s:</label>
                    <select placeholder="Seleccione el pa&iacute;s" formControlName="countryId" class="form-control"
                        (change)="onSelectCountry()"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['countryId'].errors }">
                        <option *ngFor="let country of countries" [value]="country.Id">{{country.Name}}</option>
                    </select>
                    <div *ngIf="organizationSubmitted && organizationControls['countryId'].errors"
                        class="invalid-feedback">
                        <div *ngIf="organizationControls['countryId'].errors['required']">El pa&iacute;s es requerido.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="stateId" class="required">Provincia:</label>
                    <select placeholder="Seleccione la provincia" formControlName="stateId" class="form-control"
                        (change)="onSelectState()"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['stateId'].errors }">
                        <option *ngFor="let state of states" [ngValue]="state.Id">{{state.Name}}</option>
                    </select>
                    <div *ngIf="organizationSubmitted && organizationControls['stateId'].errors"
                        class="invalid-feedback">
                        <div *ngIf="organizationControls['stateId'].errors['required']">La provincia es requerida.</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="cityId" class="required">Cant&oacute;n:</label>
                    <select placeholder="Seleccione el cant&oacute;n" formControlName="cityId" class="form-control"
                        (change)="onSelectCity()"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['cityId'].errors }">
                        <option *ngFor="let city of cities" [ngValue]="city.Id">{{city.Name}}</option>
                    </select>
                    <div *ngIf="organizationSubmitted && organizationControls['cityId'].errors"
                        class="invalid-feedback">
                        <div *ngIf="organizationControls['cityId'].errors['required']">El cant&oacute;n es requerido.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="districtId" class="required">Distrito:</label>
                    <select placeholder="Seleccione el distrito" formControlName="districtId" class="form-control"
                        (change)="onSelectDistrict($any($event.target).value)"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['districtId'].errors }">
                        <option *ngFor="let district of districts" [ngValue]="district.Id">{{district.Name}}</option>
                    </select>
                    <div *ngIf="organizationSubmitted && organizationControls['districtId'].errors"
                        class="invalid-feedback">
                        <div *ngIf="organizationControls['districtId'].errors['required']"> El distrito es requerido.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="neighborhoodId" class="required">Barrio:</label>
                    <select placeholder="Seleccione el barrio" formControlName="neighborhoodId" class="form-control"
                        (change)="onSelectDistrict($any($event.target).value)"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['neighborhoodId'].errors }">
                        <option *ngFor="let neighborhood of nighboorhoods" [ngValue]="neighborhood.Id">
                            {{neighborhood.Name}}</option>
                    </select>
                    <div *ngIf="organizationSubmitted && organizationControls['neighborhoodId'].errors"
                        class="invalid-feedback">
                        <div *ngIf="organizationControls['neighborhoodId'].errors['required']"> El barrio es requerido.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="address">Direcci&oacute;n:</label>
                    <textarea class="form-control" formControlName="address" rows="3"
                        placeholder="Ingrese la direcci&oacute;n"
                        [ngClass]="{'is-invalid': organizationSubmitted && organizationControls['address'].errors }"></textarea>
                    <div *ngIf="organizationSubmitted && organizationControls['address'].errors"
                        class="invalid-feedback">
                        <div *ngIf="organizationControls['address'].errors['required']">La direcci&oacute;n es
                            requerida.
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-12 col-md-6">
            </div>
            <div class="col-12 col-md-6 text-center">
                <button type="submit" class="btn btn-primary btn-block" style="margin: 3px;">Siguiente</button>
                <button type="button" class="btn btn-secondary btn-block" style="margin: 3px;"
                    (click)="onCancel()">Cancelar</button>
            </div>
        </div>
    </form>
    <form [formGroup]="userAccountForm" class="formClass boxed" *ngIf="activeIndex == 1"
        (ngSubmit)="onSubmitAccount();">
        <div class="row">
            <div class="col-12 col-md-6">

                <div class="form-group">
                    <label for="name" class="required">Nombre:</label>
                    <input type="text" class="form-control" formControlName="name"
                        placeholder="Ingrese el nombre de la organizacion"
                        [ngClass]="{'is-invalid': userAccountSubmitted && userAccountControls['name'].errors }">
                    <div *ngIf="userAccountSubmitted && userAccountControls['name'].errors" class="invalid-feedback">
                        <div *ngIf="userAccountControls['name'].errors['required']">El nombre es requerido.</div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="emailAddress" class="required">Correo electr&oacute;nico:</label>
                    <input type="text" class="form-control" formControlName="emailAddress"
                        placeholder="Ingrese el correo electr&oacute;nico"
                        [ngClass]="{'is-invalid': userAccountSubmitted && userAccountControls['emailAddress'].errors }">
                    <div *ngIf="userAccountSubmitted && userAccountControls['emailAddress'].errors"
                        class="invalid-feedback">
                        <div *ngIf="userAccountControls['emailAddress'].errors['required']">El correo es requerido.
                        </div>
                        <div *ngIf="userAccountControls['emailAddress'].errors['email']">Formato de correo
                            inv&aacute;lido.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">

                <div class="row securityContainer">
                    <div class="col-12 security">
                        <h3>Informaci&oacute;n de seguridad:</h3>
                        <div class="form-group">
                            <label for="loginName" class="required">Id de usuario:</label>
                            <input type="text" class="form-control" maxlength="100" formControlName="loginName"
                                placeholder="Ingrese el login name"
                                [ngClass]="{'is-invalid': userAccountSubmitted && userAccountControls['loginName'].errors }">
                            <div *ngIf="userAccountSubmitted && userAccountControls['loginName'].errors"
                                class="invalid-feedback">
                                <div *ngIf="userAccountControls['loginName'].errors['required']">El correo es requerido.
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="password" class="required">Password: <i
                                    class="fa fa-question-circle"></i></label>
                            <input type="password" class="form-control" maxlength="100" formControlName="password"
                                placeholder="Ingrese el Password"
                                [ngClass]="{'is-invalid': userAccountSubmitted && userAccountControls['password'].errors  }">
                            <small class="form-text text-muted">Ingrese 8 caracteres y debe incluir mayúsculas,
                                minúsculas, números y caracteres especiales.</small>
                            <div *ngIf="userAccountSubmitted && userAccountControls['password'].errors"
                                class="invalid-feedback">
                                <div *ngIf="userAccountControls['password'].errors['required']">El password es
                                    requerido.
                                </div>
                            </div>
                            <syn-password-strength [passwordToCheck]="userAccountForm.value.password"
                                (passwordStrength)="onPasswordValid($event)"></syn-password-strength>
                        </div>
                        <div class="form-group">
                            <label for="passwordConfirm" class="required">Confirmar Contraseña:</label>
                            <input type="password" class="form-control" maxlength="100"
                                formControlName="passwordConfirm" placeholder="Confirme el Password"
                                [ngClass]="{'is-invalid': userAccountSubmitted && (userAccountControls['passwordConfirm'].errors || !passwordMatch) }">
                            <div *ngIf="userAccountSubmitted && userAccountControls['passwordConfirm'].errors"
                                class="invalid-feedback">
                                <div *ngIf="userAccountControls['passwordConfirm'].errors['required']">Debe confirmar el
                                    password.
                                </div>
                            </div>
                            <div *ngIf="userAccountSubmitted && !passwordMatch" class="invalid-feedback">
                                <div>El password ingresado no coincide.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
            </div>
            <div class="col-12 col-md-6 text-center">
                <button type="button" class="btn btn-dark btn-block" style="margin: 3px;"
                    (click)="onPrevious()">Anterior</button>
                <button type="submit" class="btn btn-primary btn-block" style="margin: 3px;"
                    [disabled]="!passwordIsValid">Siguiente</button>
                <button type="button" class="btn btn-secondary btn-block" style="margin: 3px;"
                    (click)="onCancel()">Cancelar</button>
            </div>
        </div>
    </form>
    <form [formGroup]="confirmationForm" class="formClass boxed" *ngIf="activeIndex == 2"
        (ngSubmit)="onSubmitConfirmation();">
        <div class="row">
            <div class="col-12">
                <div class="termsBox">
                    <div>
                        <h1>T&eacute;rminos y Condiciones</h1>
                        <h3>Pol&iacute;tica de privacidad</h3>
                        <p align='justify'>XmartBusiness es un producto propiedad intelectual de Synergy Technology de Costa Rica.
                            Este documento rige su relación con XmartBusiness ("Sitio web"). El acceso y el uso de este sitio
                            web
                            y los productos y servicios disponibles a través de este sitio web (colectivamente, los
                            "Servicios") están sujetos a los siguientes términos, condiciones y avisos (los "Términos
                            del
                            servicio"). Al utilizar los Servicios, acepta todos los Términos del Servicio, según sea
                            actualizado por nosotros de vez en cuando. Debe revisar esta página regularmente para
                            enterarse
                            de cualquier cambio que hayamos hecho en los Términos del Servicio. El acceso a este sitio
                            web
                            está permitido de forma temporal, y nos reservamos el derecho de retirar o modificar los
                            Servicios sin previo aviso. No seremos responsables si por algún motivo este sitio web no
                            está
                            disponible en cualquier momento o durante cualquier período. Nos reservamos el derecho de 
                            restringir el acceso a algunas partes o a todo este sitio web. Este sitio web puede contener
                            enlaces a otros sitios web (los "Sitios vinculados"), que no son operados por
                            Synergy Technology S.A .
                            Synergy Technology S.A no tiene control sobre los Sitios Enlazados y no acepta ninguna
                            responsabilidad por ellos o por cualquier pérdida o daño que pueda surgir de su uso de ellos. Su uso de los
                            Sitios Enlazados estará sujeto a los términos de uso y servicio contenidos dentro de cada
                            uno de
                            dichos sitios. Nuestra política de privacidad, que establece cómo usaremos su información,
                            se
                            puede encontrar en [Enlace de política de privacidad]. Al usar este sitio web, usted acepta
                            el
                            procesamiento descrito allí y garantiza que todos los datos proporcionados por usted son
                            precisos. </p>
                        <h3>Prohibiciones</h3>
                        <p align='justify'>No debe hacer un mal uso de este sitio web. Usted no: cometerá ni fomentará
                            una
                            ofensa criminal; transmitir o distribuir un virus, troyano, gusano, bomba lógica o cualquier
                            otro material que sea malicioso, tecnológicamente dañino, en contra de la confianza o de
                            alguna
                            manera ofensivo o obsceno; piratear cualquier aspecto del Servicio; datos corruptos; causar
                            molestias a otros usuarios; infringir los derechos de los derechos de propiedad de otra
                            persona;
                            enviar cualquier publicidad no solicitada o material promocional, comúnmente conocido como
                            "spam"; o intentar afectar el rendimiento o la funcionalidad de las instalaciones de
                            cualquier
                            computadora o acceso a través de este sitio web. Infracción de esta disposición constituiría
                            una
                            ofensa criminal y Synergy Technology se reservara el derecho de informar cualquier infracción a las autoridades
                            competentes y les revelará su identidad. </p>
                        <p align='justify'>No seremos responsables por ninguna pérdida o daño causado por un ataque
                            distribuido de denegación de servicio, virus u otro material tecnológicamente dañino que
                            pueda
                            infectar su equipo informático. programas informáticos, datos u otro material patentado
                            debido a
                            su uso de este sitio web o a la descarga de cualquier material publicado en él, o en
                            cualquier
                            sitio web vinculado a él. </p>
                        <h3>Propiedad intelectual, software y contenido </h3>
                        <p align='justify'>Los derechos de propiedad intelectual en todo el software y contenido
                            (incluidas
                            las imágenes, documentos y otros) puestos a su disposición en este sitio web o en él son propiedad
                            de
                            Synergy Technology S.A. o sus licenciantes y están protegidos por leyes de derechos de autor y
                            tratados
                            en torno el mundo Todos los derechos están reservados por Synergy Technology S.A. y sus
                            licenciantes.
                            Puede almacenar, imprimir y mostrar el contenido suministrado únicamente para su uso
                            personal.
                            No se le permite publicar, manipular, distribuir o reproducir, en ningún formato, ninguno de
                            los
                            contenido o copias del contenido proporcionado a usted o que aparece en este sitio web ni
                            puede
                            utilizar dicho contenido en relación con cualquier empresa comercial o comercial.</p>
                        <h3>Términos de venta</h3>
                        <p align='justify'>Al registrarse usted está ofreciendo comprar un producto y está
                            sujeto a
                            los siguientes términos y condiciones. Todos los producto asi como el accesos al sitio están sujetos a disponibilidad. 
							Para contratar y registrarse en XmartBusiness, debe ser
                            mayor
                            de 18 años y poseer una tarjeta de crédito o débito válida emitida por un banco aceptable
                            para
                            nosotros.  Synergy Technology S.A. se reserva el derecho de rechazar cualquier solicitud hecha por
                            usted. Si su pedido es aceptado, le informaremos por correo electrónico y confirmaremos la
                            identidad de la parte con la que ha contratado. Al registrarse, se compromete a
                            que
                            todos los datos que nos proporciona son ciertos y precisos, que es un usuario autorizado de
                            la
                            tarjeta de crédito o débito utilizada para realizar su pedido y que hay fondos suficientes
                            para
                            cubrir el costo de los bienes. El costo de productos y servicios extranjeros puede fluctuar.
                            Todos los precios anunciados están sujetos a dichos cambios. </p>
                        <h3>Condiciones del servicio</h3>
                        <ol type='a'>
                            <li>
                                <p align='justify'>Nuestro contrato Cuando realiza un pedido, recibirá un correo
                                    electrónico
                                    de
                                    confirmación confirmando la recepción de su pedido: este correo electrónico solo
                                    será un
                                    reconocimiento y no constituirá una aceptación de su pedido. No se formará un
                                    contrato
                                    entre nosotros hasta que le enviemos la confirmación por correo electrónico de que
                                    le
                                    han enviado los productos que usted ordenó. Solo los bienes enumerados en el correo
                                    electrónico de confirmación enviado en el momento del envío se incluirán en el
                                    contrato
                                    formado. </p>
                            </li>
                            <li>
                                <p align='justify'>Fijación de precios y disponibilidad Aunque tratamos de garantizar
                                    que
                                    todos los
                                    detalles, descripciones y precios que aparecen en este El sitio web es preciso,
                                    pueden
                                    ocurrir errores. Si descubrimos un error en el precio de cualquier producto que ha
                                    solicitado, le informaremos de esto lo antes posible y le daremos la opción de
                                    reconfirmar su pedido al precio correcto o cancelarlo. Si no podemos contactarlo,
                                    trataremos el pedido como cancelado. Si cancela y ya pagó los bienes, recibirá un
                                    reembolso completo. Los costos de entrega serán cargados además; dichos cargos
                                    adicionales se muestran claramente cuando corresponde y se incluyen en el 'Costo
                                    total'.
                                </p>
                            </li>
                            <li>
                                <p align='justify'>Pago Al recibir su pedido, llevamos a cabo un control de autorización
                                    estándar en su
                                    pago tarjeta para garantizar que haya fondos suficientes para completar la
                                    transacción.
                                    Su tarjeta será debitada cuando se reciba la autorización. El dinero recibido al
                                    cargar
                                    su tarjeta se tratará como un depósito contra el valor de los bienes que desea
                                    comprar.
                                    Una vez que los bienes han sido despachados y se le ha enviado un correo electrónico
                                    de
                                    confirmación, el dinero pagado como depósito se utilizará como contraprestación por
                                    el
                                    valor de los bienes que ha comprado, tal como figura en el correo electrónico de
                                    confirmación. (NECESITO SABER QUÉ OTROS MÉTODOS DE PAGOS EXISTEN O QUE ESTEN DENTRO
                                    DE
                                    NUESTRAS POSIBILIDAD DE OFRECER; PORQUE DE ELLO DEPENDEN TAMBIÉN LOS TÉRMINOS Y
                                    CONDICIONES)</p>
                            </li>
                        </ol>
                        <h3>Descargo de responsabilidad</h3>
                        <p align='justify'> El material que se muestra en este sitio web se proporciona sin garantías,
                            condiciones o garantías en cuanto a su precisión. A menos que se indique expresamente lo
                            contrario en toda su extensión permitido por ley Synergy Tecnology S.A. y sus proveedores,
                            proveedores
                            de contenido y anunciantes excluyen expresamente todas las condiciones, garantías y otros
                            términos que de otro modo estarían implícitos en el estatuto, la ley común o la ley de
                            equidad y
                            no serán responsables por ningún daño en absoluto , incluyendo pero no limitándose a
                            cualquier
                            daño directo, indirecto, especial, consecuente, punitivo o incidental, o daños por pérdida
                            de
                            uso, ganancias, datos u otros intangibles, daños a la buena voluntad o reputación, o el
                            costo de
                            adquisición de bienes y servicios sustitutos , que surjan o estén relacionados con el uso,
                            la
                            incapacidad de uso, el rendimiento o las fallas de este sitio web o los sitios vinculados y
                            cualquier material publicado al respecto, independientemente de si tales daños fueron
                            previsibles o surgieron en un contrato, agravio, equidad, restitución, por estatuto, en la
                            ley
                            común o de otra manera. Esto no afecta la responsabilidad de Synergy Tecnology S.A. por muerte o
                            lesiones personales derivadas de su negligencia, tergiversación fraudulenta, tergiversación
                            en
                            cuanto a un asunto fundamental o cualquier otra responsabilidad que no pueda ser excluida o
                            limitada por la ley aplicable. No debe suponerse que los métodos, técnicas y herramientas de
                            negociación presentados en esta página serán rentables o que no darán lugar a pérdidas. Los
                            resultados anteriores no son necesariamente indicativos de resultados futuros. Los ejemplos
                            en
                            esta página son solo para fines educativos. Esto no es una solicitud de ninguna orden para
                            comprar o vender.</p>
                        <p align='justify'>Los autores y el editor no asumen ninguna responsabilidad por las acciones
                            tomadas por los lectores y asistentes. Los autores y el editor no brindan asesoramiento de
                            inversión. Los autores y el editor no hacen ningún reclamo, promesa o garantía de que
                            cualquier
                            sugerencia, sistema, estrategia comercial o información resulte en ganancias, pérdidas o
                            cualquier otro resultado deseado. Todos los lectores y usuarios asumen todos los riesgos,
                            incluidos, entre otros, el riesgo de pérdidas comerciales. Active Trading puede ocasionar
                            grandes pérdidas y puede no ser una actividad adecuada para todos. </p>
                        <h3>Vinculación a este sitio web</h3>
                        <p align='justify'>Puede vincular a nuestra página de inicio, siempre que lo haga de manera
                            justa y
                            legal y no dañe nuestra reputación ni la aproveche, pero no debe establecer un enlace en tal
                            una
                            forma de sugerir cualquier forma de asociación, aprobación o respaldo de nuestra parte donde
                            no
                            exista ninguna. No debe establecer un enlace desde ningún sitio web que no sea de su
                            propiedad.
                            Este sitio web no debe estar enmarcado en ningún otro sitio, ni puede crear un enlace a
                            ninguna
                            parte de este sitio web que no sea la página de inicio. Nos reservamos el derecho de retirar
                            el
                            permiso de enlace sin previo aviso. Descargo de responsabilidad sobre la propiedad de marcas
                            comerciales, imágenes de personalidades y derechos de autor de terceros. Salvo que se
                            indique
                            expresamente lo contrario, todas las personas (incluidos sus nombres e imágenes), las marcas
                            registradas de terceros y los contenidos, servicios y / o ubicaciones incluidas en este
                            sitio
                            web están de ninguna manera asociado, vinculado o afiliado Synergy Tecnology S.A. y usted no debe
                            confiar en la existencia de tal conexión o afiliación. Cualquier marca / nombre que aparezca
                            en
                            este sitio web es propiedad de los respectivos propietarios de la marca. Cuando se hace
                            referencia a una marca o nombre de marca, se utiliza únicamente para describir o identificar
                            los
                            productos y servicios, y de ninguna manera es una afirmación de que dichos productos o
                            servicios
                            están respaldados por o conectados a Synergy Tecnology S.A.</p>
                        <p align='justify'>Usted acepta indemnizar, defender y eximir de responsabilidad a
                            Synergy Tecnology S.A., su director, funcionarios, empleados, consultores, agentes y afiliados, de
                            cualquier reclamación de terceros, responsabilidad, daños y / o costos (incluyendo, pero no
                            limitado a, honorarios legales) que surjan de su uso de este sitio web o su incumplimiento
                            de
                            los Términos del Servicio.</p>
                        <h3>Variation</h3>
                        <p align='justify'>Synergy Tecnology S.A.tendrá el derecho a su absoluta discreción en cualquier
                            momento
                            y sin previo aviso para modificar, eliminar o modificar los Servicios y / o cualquier página
                            de
                            este sitio web.</p>
                        <h3>Invalidez</h3>
                        <p align='justify'>Si alguna parte de los Términos de servicio no es exigible (incluida
                            cualquier
                            disposición en la que excluyamos nuestra responsabilidad hacia usted), la aplicabilidad de
                            cualquier otra parte de los Términos de servicio no se verá afectada, todas las demás
                            cláusulas
                            permanecerán en pleno vigor y efecto. En la medida de lo posible, cuando cualquier cláusula
                            /
                            subcláusula o parte de una cláusula / subcláusula pueda separarse para que la parte restante
                            sea
                            válida, la cláusula se interpretará en consecuencia. Alternativamente, usted acepta que la
                            cláusula se rectificará e interpretará de tal manera que se asemeje mucho a la significado
                            original de la cláusula / subcláusula según lo permita la ley.</p>
                        <h3>Quejas</h3>
                        <p align='justify'>Operamos un procedimiento de manejo de quejas que usaremos para tratar de
                            resolver disputas cuando surjan por primera vez, por favor infórmenos si tiene alguna queja
                            o
                            comentario.</p>
                        <h3>Renuncia</h3>
                        <p align='justify'>Si incumple estas condiciones y no tomamos ninguna medida, aún tendremos
                            derecho
                            a utilizar nuestros derechos y recursos en cualquier otra situación en la que incumpla estas
                            condiciones.</p>
                        <h3>Acuerdo completo</h3>
                        <p align='justify'>Los Términos de servicio anteriores constituyen el acuerdo completo de las
                            partes
                            y reemplazan a todos los acuerdos anteriores y contemporáneos entre usted y
                           Synergy Tecnology S.A.
                            Cualquier renuncia a cualquier disposición de los Términos del Servicio será efectiva solo
                            si es
                            escrito y firmado por el director de Synergy Tecnology S.A.</p>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="input-group">
                    <div class="form-group">
                        <label for="agreeTerms" style="font-weight: 700;">
                            <input type="checkbox" formControlName="agreeTerms" class="checkbox"
                                [ngClass]="{'is-invalid': confirmationSubmittted && confirmationControls['agreeTerms'].errors  }">He
                            le&iacute;do los t&eacute;rminos y
                            condiciones y estoy de acuerdo.
                        </label>
                        <div *ngIf="confirmationSubmittted && confirmationControls['agreeTerms'].errors"
                            class="invalid-feedback">
                            <div *ngIf="confirmationControls['agreeTerms'].errors['pattern']">Debe aceptar los
                                t&eacute;rminos y condiciones.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
            </div>
            <div class="col-12 col-md-6 text-center">
                <button type="button" class="btn btn-dark btn-block"  style="margin: 3px;" (click)="onPrevious()">Anterior</button>
                <button type="submit" class="btn btn-primary btn-block" style="margin: 3px;" >Siguiente</button>
                <button type="button" class="btn btn-secondary btn-block"style="margin: 3px;" (click)="onCancel()">Cancelar</button>
            </div>
        </div>
    </form>
</div>
<synergy-spinner [show]="loading"></synergy-spinner>